import React from 'react';
import '../css/LoadingScreen.css';
import logo from '../assets/img/condamind-logo.png';

const LoadingScreen = () => {
    return (
        <div className="loading-container">
            <img src={logo} alt="Logo" className="loading-logo"/>
        </div>
    );
}

export default LoadingScreen;
